import React from 'react'
import styles from './FormGroup.module.scss'

const FormGroup = ({ children, className, ...rest }) => (
    <div
        className={`${styles.formgroup} ${className ? className : ''}`}
        {...rest}
    >
        {children}
    </div>
)

export { FormGroup }
